module.exports = __webpack_public_path__ + "img/talent_concept_2.303ea16b.png";